import {useSession} from 'next-auth/react';
import {useState, useEffect} from 'react';
import AthenaAPI from '../../APIs/AthenaAPI';
import {AgeniumUser} from '@amplify/athena-models';

let cachedUser: AgeniumUser | null = null;

//process.env.NEXT_PUBLIC_SST_STAGE !== 'prod'

export const useAgeniumUser = () => {
    const {data: session} = useSession();
    const [ageniumUser, setAgeniumUser] = useState<AgeniumUser | null>(cachedUser);
    const [loading, setLoading] = useState(!cachedUser);
    const [error, setError] = useState<Error | null>(null);
    const [ageniumUserPromise, setAgeniumUserPromise] = useState<Promise<AgeniumUser | null> | null>(null);

    useEffect(() => {
        const fetchUser = async (): Promise<AgeniumUser | null> => {
            setLoading(true);
            const internalUser = await AthenaAPI.getInternalUser(session?.user?.email as string);
            cachedUser = internalUser?.ageniumUserData || null;

            if (!cachedUser && process.env.NEXT_PUBLIC_SST_STAGE !== 'prod') {
                cachedUser = {
                    keyedContractNumber: '6016101',
                    agentKeyedFirstName: 'Seymour',
                    agentKeyedLastName: 'Data',
                    agentAssisted: true,
                    agentAssistedContractNumber: '6016101',
                };
            }

            setAgeniumUser(cachedUser);
            setError(null);
            setLoading(false);
            return cachedUser || null;
        };

        const promise = fetchUser();
        setAgeniumUserPromise(promise);
    }, [session?.user?.email]);

    return {
        ageniumUser,
        loading,
        error,
        ageniumUserPromise,
    };
};
